import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import icons from '../../config/assets/icons/index';
import { TEXT } from '../../constant/textConstants';
import { ROUTE } from '../../constant/routeConstants';
import { useDispatch, useSelector } from 'react-redux';
import { generateLocalizedPath } from '../../services/utils';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { setSelectedTagData, setTagDetails } from '../../store/tags/reducer';
import { setAppDetails, setSelectedAppData } from '../../store/application/reducer';

const AppTagHeader = ({ type, selectedSectionInd, setSelectedSectionInd }) => {
  const { lang } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { tag, app } = useSelector((state) => state);

  useEffect(() => {
    if (tag?.selectedTagData !== null) {
      setSelectedSectionInd(0);
    }
    if (app?.selectedAppData !== null) {
      setSelectedSectionInd(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleTab = () => {
    if (type === 'dashborad') {
      dispatch(setTagDetails(null));
      dispatch(setAppDetails(null));
      dispatch(setSelectedAppData(null));
      dispatch(setSelectedTagData(null));
    }
  };

  const hasTagsOnDashboard =
    pathname?.includes(ROUTE?.DASHBOARD) &&
    (tag?.tagList?.MyOpenTags?.length > 0 ||
      tag?.tagList?.RepliedTags?.length > 0 ||
      tag?.tagList?.ReplyAwaitedTags?.length > 0);

  const hasTagsOutsideDashboard =
    !pathname?.includes(ROUTE?.DASHBOARD) &&
    (app?.appDetails?.TagId !== 0 || (tag?.selectedTagData && tag?.selectedTagData?.TagId !== 0));

  const shouldDisplayTags = hasTagsOnDashboard || hasTagsOutsideDashboard;

  return (
    <div className="flex items-center justify-between gap-4 border-b-[1px] px-3.5 pt-8">
      <div className="flex items-center gap-4">
        {shouldDisplayTags && (
          <div
            onClick={() => {
              toggleTab();
              setSelectedSectionInd(0);
            }}
            className={`${
              selectedSectionInd === 0 ? 'border-bright-green' : 'border-white'
            } flex cursor-pointer items-center gap-2 border-b-2 pb-1`}
          >
            <icons.tag w={18} h={18} />
            <p className="cursor-pointer py-[2px] text-subtitle2 font-semibold">
              {!pathname?.includes(ROUTE?.DASHBOARD) ? t(TEXT?.TAG) : t(TEXT?.TAGS)}
            </p>
          </div>
        )}

        <div
          onClick={() => {
            toggleTab();
            setSelectedSectionInd(1);
          }}
          className={`${selectedSectionInd === 1 ? 'border-bright-green' : 'border-white'} flex cursor-pointer items-center gap-2 border-b-2 pb-1`}
        >
          <icons.form w={18} h={18} />
          <p className="cursor-pointer py-[2px] text-subtitle2 font-semibold">
            {!pathname?.includes(ROUTE?.DASHBOARD) ? t(TEXT?.APPLICATION) : t(TEXT?.APPLICATIONS)}
          </p>
        </div>
      </div>
      {!pathname?.includes(ROUTE?.DASHBOARD) &&
        (app?.selectedAppData !== null || tag?.selectedTagData !== null) && (
          <div
            onClick={() => {
              navigate(generateLocalizedPath(lang, ROUTE?.DASHBOARD));
              dispatch(setTagDetails(null));
              dispatch(setAppDetails(null));
              dispatch(setSelectedAppData(null));
              dispatch(setSelectedTagData(null));
            }}
            className="cursor-pointer text-base font-semibold text-main"
          >
            {t(TEXT?.CLOSE)}
          </div>
        )}
    </div>
  );
};

export default AppTagHeader;
